import API from "./axios";

/**
 * Stitching Operation master — operations and the types beneath them.
 *
 * An operation and its types are saved TOGETHER: the modal edits both, and
 * splitting them across two calls would let one succeed and the other fail.
 */
const stitchingOperationApi = {
  paged:   (params = {}) => API.get("/stitching-operations/paged", { params }),
  /** Active operations for pick lists, already in line order. */
  active:  ()            => API.get("/stitching-operations/active"),
  getById: (id)          => API.get(`/stitching-operations/${id}`),
  create:  (body)        => API.post("/stitching-operations", body),
  update:  (id, body)    => API.put(`/stitching-operations/${id}`, body),
  toggle:  (id)          => API.patch(`/stitching-operations/${id}/toggle-status`),
  delete:  (id)          => API.delete(`/stitching-operations/${id}`),
};

export default stitchingOperationApi;
